/**
 * Restore an open Klaviyo form if Geolocation Flow accidentally dismisses it.
 */
(function () {
  var GEO_SELECTOR = 'xgeo-widget, .xgeo-modal';
  var GEO_INTERACTION_WINDOW = 3000;
  var lastGeoInteractionAt = 0;
  var openKlaviyoFormId = null;
  var recoveryTimer = null;
  var recoveryInProgress = false;

  function eventCameFromGeolocation(event) {
    return event.composedPath().some(function (node) {
      return (
        node instanceof Element &&
        (node.matches(GEO_SELECTOR) || node.closest(GEO_SELECTOR))
      );
    });
  }

  function rememberGeolocationInteraction(event) {
    if (eventCameFromGeolocation(event)) {
      lastGeoInteractionAt = Date.now();
    }
  }

  function geolocationModalIsOpen() {
    return Boolean(document.querySelector('.xgeo-modal[data-open]'));
  }

  function reopenKlaviyoFormWhenReady(formId) {
    window.clearTimeout(recoveryTimer);

    function attemptReopen() {
      if (geolocationModalIsOpen()) {
        recoveryTimer = window.setTimeout(attemptReopen, 100);
        return;
      }

      recoveryInProgress = true;
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);

      window.setTimeout(function () {
        recoveryInProgress = false;
      }, 3000);
    }

    recoveryTimer = window.setTimeout(attemptReopen, 250);
  }

  window.addEventListener('klaviyoForms', function (event) {
    var detail = event.detail;
    if (!detail || !detail.formId) return;

    if (detail.type === 'open') {
      openKlaviyoFormId = detail.formId;
      return;
    }

    if (detail.type === 'submit' || detail.type === 'redirectedToUrl') {
      openKlaviyoFormId = null;
      return;
    }

    if (detail.type !== 'close' || recoveryInProgress) return;

    var closedDuringGeoInteraction =
      geolocationModalIsOpen() ||
      Date.now() - lastGeoInteractionAt < GEO_INTERACTION_WINDOW;

    if (closedDuringGeoInteraction && detail.formId === openKlaviyoFormId) {
      reopenKlaviyoFormWhenReady(detail.formId);
    }
  });

  document.addEventListener('pointerdown', rememberGeolocationInteraction, true);
  document.addEventListener('touchstart', rememberGeolocationInteraction, true);
  document.addEventListener('click', rememberGeolocationInteraction, true);
})();
